import { render, staticRenderFns } from "./DiamondButton.vue?vue&type=template&id=753b3ca1&scoped=true&"
import script from "./DiamondButton.vue?vue&type=script&lang=js&"
export * from "./DiamondButton.vue?vue&type=script&lang=js&"
import style0 from "./DiamondButton.vue?vue&type=style&index=0&id=753b3ca1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b3ca1",
  null
  
)

export default component.exports